import { MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	const values = [items[0], items[1], items[2]];

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="w/ placeholder" />
			<Text semiBold text="w/ placeholder localized" />
			<Text semiBold text="w/o placeholder" />
			<MultiSelect
				limitTags={1}
				options={items}
				placeHolder="Cities"
				value={values}
			/>
			<MultiSelect
				limitTags={1}
				options={items}
				placeHolderRes="Resource"
				placeHolderResParams={["MultiSelect"]}
				value={values}
			/>
			<MultiSelect
				limitTags={2}
				options={items}
				value={values}
			/>
		</CssColumnGrid>
	);
};